var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3172_132377)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3172_132377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29Z",
    fill: "#8484FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1 16C28.1 22.6826 22.6826 28.1 16 28.1C9.31735 28.1 3.9 22.6826 3.9 16C3.9 9.31735 9.31735 3.9 16 3.9C22.6826 3.9 28.1 9.31735 28.1 16Z",
    stroke: "#6A66D9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4014 10.375C15.4014 10.7892 15.7372 11.125 16.1514 11.125C16.5656 11.125 16.9014 10.7892 16.9014 10.375V9.625C16.9014 9.21079 16.5656 8.875 16.1514 8.875C15.7372 8.875 15.4014 9.21079 15.4014 9.625V10.375ZM16.1514 11.875C14.0803 11.875 12.4014 13.5539 12.4014 15.625V20.125H19.9014V15.625C19.9014 13.5539 18.2225 11.875 16.1514 11.875ZM10.9014 22.375C10.9014 21.9608 11.2372 21.625 11.6514 21.625H20.6514C21.0656 21.625 21.4014 21.9608 21.4014 22.375C21.4014 22.7892 21.0656 23.125 20.6514 23.125H11.6514C11.2372 23.125 10.9014 22.7892 10.9014 22.375ZM11.725 12.8995C11.5178 13.2582 11.0592 13.3811 10.7004 13.174L10.0509 12.799C9.69219 12.5919 9.56929 12.1332 9.77639 11.7745C9.9835 11.4158 10.4422 11.2929 10.8009 11.5L11.4504 11.875C11.8092 12.0821 11.9321 12.5408 11.725 12.8995ZM21.3009 13.174C20.9422 13.3811 20.4835 13.2582 20.2764 12.8995C20.0693 12.5408 20.1922 12.0821 20.5509 11.875L21.2004 11.5C21.5591 11.2929 22.0178 11.4158 22.2249 11.7745C22.4321 12.1332 22.3091 12.5919 21.9504 12.799L21.3009 13.174ZM22.9749 18.1495C22.7678 18.5082 22.3092 18.6311 21.9504 18.424L21.3009 18.049C20.9422 17.8419 20.8193 17.3832 21.0264 17.0245C21.2335 16.6658 21.6922 16.5429 22.0509 16.75L22.7004 17.125C23.0591 17.3321 23.1821 17.7908 22.9749 18.1495ZM10.0509 18.424C9.69219 18.6311 9.23349 18.5082 9.02639 18.1495C8.81928 17.7908 8.94219 17.3321 9.30091 17.125L9.95043 16.75C10.3091 16.5429 10.7678 16.6658 10.9749 17.0245C11.1821 17.3832 11.0591 17.8419 10.7004 18.049L10.0509 18.424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3172_132377",
    x: -1,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3172_132377"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.121569 0 0 0 0 0.137255 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3172_132377",
    result: "effect2_dropShadow_3172_132377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3172_132377",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3172_132377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/43f5c4b2cf8a520c4444b78b03a48b7bcab293ddfd.svg";
export { ForwardRef as ReactComponent };